import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { SideListOptionType } from '@fi-shared/types';

@Component({
    selector: 'fi-side-list2',
    templateUrl: './fi-side-list2.component.html',
    styleUrls: ['./fi-side-list2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-side-list2' },
    standalone: false,
})
export class FiSideList2Component {
    @Input() options: ISideListOptionsItem[];
    @Input() selectedOptionValues: number[] = [];
    @Input() multiOptions = false;
    @Input() singleOptionsAllowUnselect = false;
    @Input() isAdminIconHidden: boolean = false;
    @Input() isRoundedStyle: boolean = false;
    @Input() filterLabelTextId: string = 'common.filter';

    @Output() selectedOptionValuesChange = new EventEmitter<number[]>();

    @HostBinding('class.vertical-arrangement') @Input() verticalArrangement: boolean = true;
    @HostBinding('class.new-layout') @Input() isNewLayout: boolean = false;
    @HostBinding('class.horizontal-arrangement') @Input() horizontalArrangement: boolean = false;

    protected isOptionSelected(option: ISideListOptionsItem): boolean {
        return this.selectedOptionValues.indexOf(option.value) !== -1;
    }

    protected isSuperAdminIconShown(option: ISideListOptionsItem): boolean {
        return option.value === SideListOptionType.All;
    }

    protected onOptionClick(item: ISideListOptionsItem): void {
        let isChanged = false;
        const currentIndex = this.selectedOptionValues.findIndex((v) => v === item.value);
        if (currentIndex !== -1) {
            if (this.multiOptions || this.singleOptionsAllowUnselect) {
                isChanged = true;
                this.selectedOptionValues.splice(currentIndex, 1);
            }
        } else {
            isChanged = true;
            if (!this.multiOptions) {
                this.selectedOptionValues.length = 0;
            }
            this.selectedOptionValues.push(item.value);
        }
        if (isChanged) {
            this.selectedOptionValuesChange.emit(this.selectedOptionValues);
        }
    }
}
